import { getResultFromResponse, retryWithFibonacci, runAsyncSafe } from '@web3/utils';
import { apiCreateBybitWallet, bindCloudWalletReferral, produceReferralCode } from './api';
import { userCloudWalletStore, userWalletStore } from '../entry_inner';
import { debugLog } from './utils/common';

// 这里放的是一些跨store的 操作，避免循环引用
/**
 * 创建云钱包的操作
 */
export const createCloudWallet = async (referral: string) => {
  await getResultFromResponse(apiCreateBybitWallet());
  const retryTimes = 3;
  await userCloudWalletStore.refreshWalletList(true);
  const walletId = userCloudWalletStore.state.cloudWallet?.walletId;
  if (walletId) {
    // 为这个用户的云钱包创建邀请码，产品上需要提前创建这个邀请码，出错重试3次
    retryWithFibonacci(async () => {
      const [err, referralCode] = await runAsyncSafe(getResultFromResponse(produceReferralCode({ walletId })));
      if (referralCode) {
        return referralCode;
      }
      debugLog('creating referral code:', err, referralCode);
      throw err;
    }, retryTimes);
    // 为这个用户绑定邀请关系，出错重试3次
    if (referral) {
      retryWithFibonacci(async () => {
        const [err] = await runAsyncSafe(getResultFromResponse(bindCloudWalletReferral({ walletId, referralCode: referral })));
        if (err) {
          debugLog('creating referral code:', err);
          throw err;
        }
      }, retryTimes);
    }
  }
  userWalletStore.switchToBrowser();
};
